import React, { KeyboardEvent, MouseEvent } from "react";
import { createPortal } from "react-dom";
import { MachinesCancelOperatorTechnicianManagerModal } from "@src/components/organisms/modals/machines-cancel-operator-technician-modal/machines-cancel-operator-technician-modal";
import { MachinesCancelServiceTechnicianManagerModal } from "@src/components/organisms/modals/machines-cancel-service-technician-modal/machines-cancel-service-technician-modal";
import { MachinesCancelRequestDisconnectSupportModal } from "@src/components/organisms/modals/machines-cancel-request-disconnect-support-modal/machines-cancel-request-disconnect-support-modal";
import { MachinesListSupportSessionsCancelRequestModalTextTypes } from "@common/types/machines-list-types";

interface SupportCancelModalsProps {
  showOTCancelModal: boolean;
  showSTCancelModal: boolean;
  showDisconnectSupportModal: boolean;
  onConfirmOT: (e: MouseEvent | KeyboardEvent) => void;
  onConfirmST: (e: MouseEvent | KeyboardEvent) => void;
  onCancelOT: (e: MouseEvent | KeyboardEvent) => void;
  onCancelST: (e: MouseEvent | KeyboardEvent) => void;
  onCancelDisconnect: () => void;
  machineName: string;
  companyName: string;
  isConnected: boolean;
  modalTexts: MachinesListSupportSessionsCancelRequestModalTextTypes;
  disconnectTexts: MachinesListSupportSessionsCancelRequestModalTextTypes;
  loading: boolean;
  displayName?: string;
  disableConfirmAction?: boolean;
  disabledConfirmTooltip?: string;
}

export const SupportCancelModals = ({
  showOTCancelModal,
  showSTCancelModal,
  showDisconnectSupportModal,
  onConfirmOT,
  onConfirmST,
  onCancelOT,
  onCancelST,
  onCancelDisconnect,
  machineName,
  companyName,
  isConnected,
  modalTexts,
  disconnectTexts,
  loading,
  displayName = "",
  disableConfirmAction = false,
  disabledConfirmTooltip = "",
}: SupportCancelModalsProps) => {
  const modalEntryPointReference = document.getElementById(
    "modals-entry-point",
  ) as HTMLElement | null;

  if (!modalEntryPointReference) return null;

  return (
    <>
      {showOTCancelModal &&
        createPortal(
          <MachinesCancelOperatorTechnicianManagerModal
            onConfirm={onConfirmOT}
            onCancel={onCancelOT}
            machineName={machineName}
            companyName={companyName}
            isConnected={isConnected}
            modalTexts={modalTexts}
            loading={loading}
            displayName={displayName}
            disableConfirmAction={disableConfirmAction}
            disabledConfirmTooltip={disabledConfirmTooltip}
          />,
          modalEntryPointReference,
        )}

      {showSTCancelModal &&
        createPortal(
          <MachinesCancelServiceTechnicianManagerModal
            onConfirm={onConfirmST}
            onCancel={onCancelST}
            machineName={machineName}
            companyName={companyName}
            isConnected={isConnected}
            modalTexts={modalTexts}
            loading={loading}
            disableConfirmAction={disableConfirmAction}
            disabledConfirmTooltip={disabledConfirmTooltip}
          />,
          modalEntryPointReference,
        )}

      {showDisconnectSupportModal &&
        createPortal(
          <MachinesCancelRequestDisconnectSupportModal
            onCancel={onCancelDisconnect}
            modalTexts={disconnectTexts}
          />,
          modalEntryPointReference,
        )}
    </>
  );
};
